import { IOrdersListItem, IOrdersListItemAPI } from './index';

export interface IGetOrderAPI {
    order?: IOrderViewItemAPI;
}

export type IOrderViewItemAPI = IOrdersListItemAPI;

export type IOrderView = IOrdersListItem;

export type IGetOrder = {
    isError: boolean;
    order: IOrderView;
};

type IPostBillingOrderProductsAPI = {
    description?: string;
    units?: number;
    unit_price?: string;
};
type IPostBillingOrderDiscountAPI = {
    description?: string;
    amount?: string;
    amount_type?: string;
};
export type IPostBillingOrderAPI = {
    order: {
        amount?: string;
        company_id?: number;
        deduct_from_balance?: boolean;
        description?: string;
        discount?: IPostBillingOrderDiscountAPI;
        invoice_date?: string;
        payment_type?: string;
        products?: Array<IPostBillingOrderProductsAPI>;
        send_invoice?: boolean;
        send_invoice_on_date?: boolean;
        due_date?: string;
        status_manual?: string;
    };
};

type IPostBillingOrderProducts = {
    description?: string;
    units?: number;
    unitPrice?: string;
};
type IPostBillingOrderDiscount = {
    description?: string;
    amount?: string;
    amountType?: string;
};
export type IPostBillingOrder = {
    amount?: string;
    companyId?: number;
    deductFromBalance?: boolean;
    description?: string;
    discount?: IPostBillingOrderDiscount;
    invoiceDate?: string;
    dueDate?: string;
    paymentType?: string;
    products?: Array<IPostBillingOrderProducts>;
    sendInvoice?: boolean;
    sendInvoiceOnDate?: boolean;
    statusManual?: string;
    purchaseOrderNumber?: string;
};

export type IPostOrderAttributes = {
    company_id?: string;
    card_ids?: string[];
    card_set_ids?: string[];
    card_set_id?: string;
    amount?: number;
    description?: string;
    orderable_id?: string;
    orderable_type?: string;
    payment_type?: string;
    metadata?: Record<string, any>;
};

export interface IPostPackageOrderAttributes extends IPostOrderAttributes {
    amount?: number;
    companyId?: number;
    options?: {
        renewal?: boolean;
    };
}

export type IOrderFormStatus = 'CREATED_ORDER' | 'REDIRECT';

export type IResponsePostCheckOutDataAPI = {
    order: IOrdersListItemAPI;
};

export type IOrderExternalStatus = 'INIT' | 'NOT_GET_ORDER_ID' | 'FOUND_ORDER' | 'IS_FOUND' | 'NOT_FOUND';

export enum OrderBy {
    COMPANY = 'company',
    SUBSCRIPTION = 'subscription',
}
